export { getTabs } from './tabs';
export {
  addressSchema,
  managementSchema,
  contactDetailSchema,
  generalDetailsSchema,
  personSchema,
  organisationSchema,
  createEditIndividualSchema,
  createEditOrganisationSchema,
} from './formSchemas';
export {
  getIndividualInput,
  getOrganisationInput,
  getInitialValues,
} from './reshapeFuncs';
export { handleCreate, handleUpdate } from './handleMutation';
